let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eo1Nf")).then(() => parcelRequire('1h2Il'));